<ag-grid-angular #backgroundJobsGrid fxFlex class="ag-theme-vdw background-jobs-list-container" [gridOptions]="gridOptionsForListOfBackgroundJobs" [rowData]="backgroundTaskWithJobs"></ag-grid-angular>
